/**
 * Browser-specific entry point for SmarterElements
 * Provides clean global API: new SmarterElements()
 */

// Import the main class and utilities
import { SmarterElements as SmarterElementsClass, ElementInstance } from './core';
import { createJWT, decodeJWT } from './utils/jwt';
import { debounce, throttle } from './utils/debounce';
import { useSmarterElements } from './hooks/useSmarterElements';
import { SmarterElement } from './components/SmarterElement';

// Create a clean browser export that preserves the constructor
const SmarterElements = SmarterElementsClass;

// Attach utilities as static properties for browser access
// Do this after ensuring it's still a constructor
Object.defineProperty(SmarterElements, 'createJWT', { value: createJWT, enumerable: false });
Object.defineProperty(SmarterElements, 'decodeJWT', { value: decodeJWT, enumerable: false });
Object.defineProperty(SmarterElements, 'debounce', { value: debounce, enumerable: true });
Object.defineProperty(SmarterElements, 'throttle', { value: throttle, enumerable: true });
Object.defineProperty(SmarterElements, 'useSmarterElements', { value: useSmarterElements, enumerable: false });
Object.defineProperty(SmarterElements, 'SmarterElement', { value: SmarterElement, enumerable: false });
Object.defineProperty(SmarterElements, 'ElementInstance', { value: ElementInstance, enumerable: false });

// For browser global access, assign to globalThis/window
// This must happen before the export to ensure the constructor is available
if (typeof globalThis !== 'undefined') {
  (globalThis as any).SmarterElements = SmarterElements;
} else if (typeof window !== 'undefined') {
  (window as any).SmarterElements = SmarterElements;
}

// Export the class as default for module systems
export default SmarterElements;
